import { XepptClient } from '@xeppt/xeppt-sdk';

const BASE = '/admin/funds-flow';

// Not yet published on the @xeppt/xeppt-sdk AdminService — this local service talks
// to the same backend endpoint directly via XepptClient, mirroring the AmlSettingsService
// / EpsSettingsService pattern used for other admin-only endpoints that predate their SDK
// counterpart. Follow-up: fold this into AdminService once the SDK is bumped.
export type TFundsFlowBucket = 'in_edge' | 'out_edge' | 'internal';

export type TFundsFlowRequest = {
    date_from: string;
    date_to: string;
    statuses?: number[];
};

export type TFundsFlowKpis = {
    money_in: number;
    money_out: number;
    net_external: number;
    internal_volume: number;
    fees_earned: number;
    movement_count: number;
};

export type TFundsFlowOpRow = {
    op_key: string;
    method: number;
    type: number;
    action: number;
    label: string;
    bucket: TFundsFlowBucket;
    amount: number;
    fee: number;
    count: number;
};

export type TFundsFlowBucketRow = {
    bucket: TFundsFlowBucket;
    amount: number;
    count: number;
};

export type TFundsFlowCurrencyBlock = {
    currency: string;
    kpis: TFundsFlowKpis;
    by_op: TFundsFlowOpRow[];
    by_bucket: TFundsFlowBucketRow[];
};

export type TFundsFlowResponse = {
    currencies: TFundsFlowCurrencyBlock[];
};

export class FundsFlowService {
    constructor(private readonly client: XepptClient) {}

    getFundsFlow(payload: TFundsFlowRequest): Promise<TFundsFlowResponse> {
        return this.client.request({ method: 'POST', url: BASE, body: payload });
    }
}
